import type { AxiosRequestConfig, Method } from "axios";
import type { InjectionKey, Ref } from "vue";

/**
 * 全局字典注入
 */
export const DICT_STORE = Symbol("dictStore") as InjectionKey<{
  dict: Ref<Record<string, any>>;
  getDict: (dictType: string) => Promise<any[]>;
}>;

export interface IMenuStore {
  // 当前激活菜单
  // todo any => class.Menu
  currentMenu: Ref<any>;
  getCurrentMenu: () => any;
  // 包含全部菜单信息的tree
  menuTreeAll: Ref<any[]>;
  // 包含全部菜单信息的list
  menuListAll: Ref<any[]>;
}

/**
 * 菜单store
 * - 当前激活菜单: currentMenu
 * - 全部菜单tree：menuTreeAll
 * - 全部菜单list：menuListAll
 */
export const MENU_STORE = Symbol("MENU_STORE") as InjectionKey<IMenuStore>;

/**
 * http请求方法注入
 */
export const HTTP_REQ = Symbol("HTTP_REQ") as InjectionKey<{
  request: <T>(
    method: Method,
    url: string,
    param?: AxiosRequestConfig,
    config?: any,
  ) => Promise<T>;
  productionReq: <T>(
    method: Method,
    url: string,
    param?: AxiosRequestConfig,
  ) => Promise<T>;
  systemReq: <T>(
    method: Method,
    url: string,
    param?: AxiosRequestConfig,
  ) => Promise<T>;
  aiReq: <T>(
    method: Method,
    url: string,
    param?: AxiosRequestConfig,
  ) => Promise<T>;
  busReq: <T>(
    method: Method,
    url: string,
    param?: AxiosRequestConfig,
  ) => Promise<T>;
}>;

/**
 * userInfo 注入
 */
export const USER_INFO = Symbol("USER_INFO") as InjectionKey<{
  username: string;
  roles: any[];
  verifyCode: string;
  currentPage: number;
  isRemembered: boolean;
  loginDay: number;
  userInfo: {
    roleId?: number;
    nickName?: string;
    phoneNumber?: string;
    userName?: string;
    userType?: string;
    roleName?: string;
    enterpriseName?: string;
    tenantId?: number;
    tenantEnterpriseId?: number;
    tenantEnterpriseDeptId?: number;
    userId?: number;
    id?: string;
    soldierUserId?: string;
    avatar?: string;
    roles?: any;
  };
}>;

/**
 * 站点单位store 注入
 */
export const SITE_UNIT_STORE = Symbol("SITE_UNIT_STORE") as InjectionKey<{
  tenantList: any[];
  tenantEnterprise: any[];
  currentTenantId: number;
  currentEnterpriseId: number;
  getCurrentTenantId: number;
  getCurrentEnterpriseId: number | number[];
  SET_CURRENT_TENANT_ID: (id: number) => void;
  SET_CURRENT_ENTERPRISE_ID: (id: number | number[]) => void;
  getEnterprise: (
    isSet?: boolean,
    tenantId?: number | string,
  ) => Promise<any[]>;
  getTenantList: () => Promise<any[]>;
}>;

/**
 *  注入系统配置serverConfig.json
 */
export const SERVER_CONFIG = Symbol("SERVER_CONFIG") as InjectionKey<
  Record<string, any>
>;

/**
 * 注入主题
 */
export const THEME_STORE = Symbol("SYSTEM_THEME") as InjectionKey<Ref<string>>;
